import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnershipsComponent } from './partnerships.component';
import { PartnershipsJoinUsComponent } from './partnerships-join-us/partnerships-join-us.component';
import { SharedModule } from 'src/app/shared-components/shared.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    PartnershipsComponent,
    PartnershipsJoinUsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule
  ]
})
export class PartnershipsModule { }
